import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar,
  Input,
  Select
} from "../../../../../_metronic/_partials/controls";
import { generateYearsBetween } from "../../../../config/helper";
import CurrencyInput from "react-currency-input-field";
import {
  ORGANIZATION_REPORT_STATUS,
  REPORT_ATTACHMENT
} from "../OrganizationReportUIHelpers";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import { findDonationConsolidation } from "../../_redux/organizationReportCrud";
import DonationTableList from "./DonationTableList";
import DonationDetail from "./DonationDetail";
import { toast } from "react-toastify";

// Validation schema
const OrganizationReportEditSchema = Yup.object().shape({
  year: Yup.string().required("Tahun wajib diisi"),
  month: Yup.string().required("Bulan wajib diisi"),
  bank_name: Yup.string().required("Nama Bank wajib diisi"),
  bank_account: Yup.string().required("Rekening Bank wajib diisi"),
  bank_account_behalf: Yup.string().required("Atas Nama Bank wajib diisi")
  // zakat: Yup.string().required("Zakat wajib diisi"),
  // infaq: Yup.string().required("Infaq wajib diisi"),
  // alms: Yup.string().required("Sedekah wajib diisi")
});

export function OrganizationReportEditForm({
  saveOrganizationReport,
  actionsLoading,
  organizationReport,
  history,
  id
}) {
  const [reportAttachment, setReportAttachment] = useState({
    evidence_of_transfer: null,
    disbursement_form: null,
    fund_use_plan: null,
    prev_month_financial: null,
    activity_report: null
  });
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: {
      year: new Date().getFullYear(),
      month: new Date().toLocaleString("id", { month: "numeric" }),
      is_consolidated: false,
      organization_report_uuid: null
    }
  });

  const [selectedDonation, setSelectedDonation] = useState([]);

  const [donationResponse, setDonationResponse] = useState({
    list: [],
    totalCount: 0,
    actionsLoading: false,
    detail_donation_count: {}
  });

  const [typeDonasi, setTypeDonasi] = useState([]);

  useEffect(() => {
    setDonationResponse(prev => ({
      ...prev,
      actionsLoading: true
    }));
    const queryParamsTemp = { ...queryParams };
    if (id) {
      queryParams.filter.month = organizationReport.month;
      queryParams.filter.year = organizationReport.year;
      queryParams.filter.is_consolidated = true;
      queryParams.filter.organization_report_uuid = id;
    }
    findDonationConsolidation(queryParamsTemp)
      .then(res => {
        const { data, detail_donation_count } = res.data;
        setDonationResponse(prev => ({
          ...prev,
          list: data.items,
          totalCount: data.total_items,
          detail_donation_count: detail_donation_count
        }));
      })
      .finally(() => {
        setDonationResponse(prev => ({
          ...prev,
          actionsLoading: false
        }));
      });
  }, [queryParams, organizationReport, id]);

  const handleChangeFilter = (keyState, value) => {
    setQueryParams(prev => ({
      ...prev,
      filter: {
        ...prev.filter,
        [keyState]: value
      }
    }));
  };

  useEffect(() => {
    if (organizationReport.uuid) {
      setReportAttachment(prev => ({
        ...prev,
        evidence_of_transfer: organizationReport.file_evidence_of_transfer,
        disbursement_form: organizationReport.file_disbursement_form,
        fund_use_plan: organizationReport.file_fund_use_plan,
        prev_month_financial: organizationReport.file_prev_month_financial,
        activity_report: organizationReport.file_activity_report
      }));
    }
  }, [organizationReport]);

  const currentYear = new Date().getFullYear();
  const years = generateYearsBetween(currentYear - 5, currentYear);
  const months = Array.from({ length: 12 }, (e, i) => {
    let data = {};
    data.label = new Date(null, i + 1, null).toLocaleDateString("id", {
      month: "long"
    });
    data.value = i + 1;

    return data;
  });

  function updateFile(event, submit) {
    const { files } = event.target;

    if (files instanceof FileList) {
      submit(files[0]);
    }
  }

  const getReportLabel = attachment => {
    let str;
    switch (attachment.toUpperCase()) {
      case REPORT_ATTACHMENT.evidence_of_transfer:
        str = "Bukti Transfer";
        break;
      case REPORT_ATTACHMENT.disbursement_form:
        str = "Form Pencairan";
        break;
      case REPORT_ATTACHMENT.fund_use_plan:
        str = "Rencana Penggunaan Dana";
        break;
      case REPORT_ATTACHMENT.prev_month_financial:
        str = "Laporan Keuangan Bulan Sebelumnya";
        break;
      case REPORT_ATTACHMENT.activity_report:
        str = "Laporan Kegiatan";
        break;

      default:
        str = "";
        break;
    }
    return str;
  };

  const countDonation = values => {
    // const data = {
    //   zakat: 0,
    //   infaq: 0,
    //   alms: 0
    // };

    // for (const donation of donationResponse.list) {
    //   for (const item of donation.donation_item) {
    //     if (item.type == "ZAKAT") {
    //       data.zakat = data.zakat + +item.amount;
    //     }
    //     if (item.type == "INFAK") {
    //       data.infaq = data.infaq + +item.amount;
    //     }
    //     if (item.type == "SEDEKAH") {
    //       data.alms = data.alms + +item.amount;
    //     }
    //   }
    // }
    // const donationUuids = selectedDonation.map(donation => donation.uuid)

    values.type_data = typeDonasi;
    saveOrganizationReport({ ...values });
  };

  const getTotalDonationAmount = () => {
    const donationsAmount = selectedDonation.reduce(
      (prev, curr) => +prev + +curr.total_amount,
      0
    );
    return donationsAmount;
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={organizationReport}
        validationSchema={OrganizationReportEditSchema}
        onSubmit={values => countDonation(values)}
      >
        {({
          handleSubmit,
          handleBlur,
          setFieldValue,
          values,
          errors,
          touched
        }) => (
          <>
            {/* {actionsLoading && (
              <div className="overlay-layer bg-transparent">
                <div className="spinner spinner-lg spinner-success" />
              </div>
            )} */}
            <Card>
              <CardHeader title="Pilih Donasi">
                <CardHeaderToolbar>
                  <button
                    className="btn btn-secondary"
                    onClick={() => history.goBack()}
                  >
                    Kembali
                  </button>
                </CardHeaderToolbar>
              </CardHeader>
              <CardBody>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>
                      <strong>Pilih Tahun</strong>
                    </label>
                    <Select
                      name="year"
                      onChange={e => {
                        setFieldValue(e.target.name, e.target.value);
                        handleChangeFilter(e.target.name, e.target.value);
                      }}
                      onBlur={handleBlur}
                      disabled={
                        values.status !== ORGANIZATION_REPORT_STATUS.DRAFT
                      }
                    >
                      {years.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </Select>
                    {errors.year && touched.year && (
                      <div style={{ color: "red" }}>{errors.year}</div>
                    )}
                  </div>
                  <div className="col-lg-4">
                    <label>
                      <strong>Pilih Bulan</strong>
                    </label>
                    <Select
                      name="month"
                      onChange={e => {
                        setFieldValue(e.target.name, e.target.value);
                        handleChangeFilter(e.target.name, e.target.value);
                      }}
                      onBlur={handleBlur}
                      disabled={
                        values.status !== ORGANIZATION_REPORT_STATUS.DRAFT
                      }
                    >
                      {months.map(month => (
                        <option key={month.value} value={month.value}>
                          {month.label.toUpperCase()}
                        </option>
                      ))}
                    </Select>
                    {errors.month && touched.month && (
                      <div style={{ color: "red" }}>{errors.month}</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label>Bank</label>
                    <input
                      name="bank_name"
                      className="form-control"
                      onChange={e => {
                        setFieldValue(e.target.name, e.target.value);
                      }}
                      placeholder="BSI / BCA / BNI"
                      value={values.bank_name}
                      disabled={
                        values.status !== ORGANIZATION_REPORT_STATUS.DRAFT
                      }
                      onBlur={handleBlur}
                    />
                    {errors.bank_name && touched.bank_name && (
                      <div style={{ color: "red" }}>{errors.bank_name}</div>
                    )}
                  </div>
                  <div className="col">
                    <label>No Rekening</label>
                    <input
                      name="bank_account"
                      className="form-control"
                      onChange={e => {
                        setFieldValue(e.target.name, e.target.value);
                      }}
                      placeholder="29273233"
                      value={values.bank_account}
                      disabled={
                        values.status !== ORGANIZATION_REPORT_STATUS.DRAFT
                      }
                      onBlur={handleBlur}
                    />
                    {errors.bank_account && touched.bank_account && (
                      <div style={{ color: "red" }}>{errors.bank_account}</div>
                    )}
                  </div>
                  <div className="col">
                    <label>Atas nama</label>
                    <input
                      name="bank_account_behalf"
                      className="form-control"
                      onChange={e => {
                        setFieldValue(e.target.name, e.target.value);
                      }}
                      placeholder="Masukkan Atas Nama"
                      value={values.bank_account_behalf}
                      disabled={
                        values.status !== ORGANIZATION_REPORT_STATUS.DRAFT
                      }
                      onBlur={handleBlur}
                    />
                    {errors.bank_account_behalf &&
                      touched.bank_account_behalf && (
                        <div style={{ color: "red" }}>
                          {errors.bank_account_behalf}
                        </div>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <DonationTableList
                      entities={donationResponse.list}
                      listLoading={donationResponse.actionsLoading}
                      totalCount={donationResponse.totalCount}
                      queryParams={queryParams}
                      setQueryParams={setQueryParams}
                      setSelectedDonation={setSelectedDonation}
                      donationResponse={donationResponse}
                    />
                  </div>
                </div>
              </CardBody>
            </Card>

            <DonationDetail id={id} data={donationResponse.detail_donation_count} onSelectType={(selectedTypes) => setTypeDonasi(selectedTypes)} />

            <Card>
              <CardHeader title="File Laporan" />
              <CardBody>
                <div
                  className="mb-16"
                  style={{
                    display: "flex",
                    flexWrap: "wrap"
                  }}
                >
                  {Object.keys(reportAttachment).map(keyState => (
                    <>
                      <div
                        className="d-flex flex-column cursor-pointer p-4"
                        style={{
                          flex: "2 1 43%",
                          margin: 4,
                          color: "#000"
                        }}
                      >
                        <label className="row" htmlFor="file">
                          <div className="col-lg-9">
                            {getReportLabel(keyState)}
                          </div>
                          <div className="col-lg-3">
                            {reportAttachment[keyState] &&
                              reportAttachment[keyState].uuid && (
                                <a
                                  onClick={() =>
                                    window.open(
                                      `${reportAttachment[keyState].storage}/${reportAttachment[keyState].path}`
                                    )
                                  }
                                >
                                  Lihat File
                                </a>
                              )}
                          </div>
                        </label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              name={keyState}
                              type="file"
                              className="custom-file-input"
                              style={{ borderColor: "blue" }}
                              // accept=".doc, .docx, .xls, .xlsx, .csv, .pdf"
                              id={keyState}
                              onChange={e =>
                                updateFile(e, value => {
                                  setFieldValue(e.target.name, value);
                                  setReportAttachment(prev => ({
                                    ...prev,
                                    [keyState]: value
                                  }));
                                })
                              }
                              disabled={
                                values.status !==
                                ORGANIZATION_REPORT_STATUS.DRAFT
                              }
                              readOnly={
                                values.status !==
                                ORGANIZATION_REPORT_STATUS.DRAFT
                              }
                            />
                            <label
                              className="custom-file-label"
                              htmlFor={keyState}
                            >
                              {reportAttachment[keyState]
                                ? reportAttachment[keyState].filename ||
                                  reportAttachment[keyState].name
                                : "Pilih file"}
                            </label>
                          </div>
                        </div>
                        <ErrorMessage
                          name="file"
                          render={msg => (
                            <span className="mt-2 text-danger">{msg}</span>
                          )}
                        />
                      </div>
                    </>
                  ))}
                </div>
              </CardBody>
              <CardFooter>
                {values.status == ORGANIZATION_REPORT_STATUS.DRAFT && (
                  <>
                    {/* <button
                    type="submit"
                    onClick={() => {
                      setFieldValue("status", ORGANIZATION_REPORT_STATUS.DRAFT);
                      handleSubmit();
                    }}
                    className="btn btn-primary btn-elevate"
                  >
                    Draft
                  </button> */}
                    <> </>
                    <button
                      type="submit"
                      onClick={() => {
                        if (typeDonasi.length < 1) {
                          return toast.error('Harap memilih type donasi pada Rekap Laporan');
                        }

                        if (donationResponse.list.length <= 0) {
                          return toast.error('Donasi item tidak ditemukan');
                        }
                        
                        setFieldValue(
                          "status",
                          ORGANIZATION_REPORT_STATUS.SUBMIT
                        );
                        handleSubmit();
                      }}
                      className="btn btn-success btn-elevate float-right"
                    >
                      Submit
                    </button>
                  </>
                )}
              </CardFooter>
            </Card>
          </>
        )}
      </Formik>
    </>
  );
}
